module.exports = __webpack_public_path__ + "static/media/Montserrat-Hairline.af3ac151.otf";